import { RMAStatus } from './rma-status.js';
/** FULFILLED counts as terminal here -- the stock is already back in the warehouse. */
export const TERMINAL_RMA_STATUS_IDS = [
    RMAStatus.FULFILLED,
    RMAStatus.CLOSED,
    RMAStatus.VOID,
];
//# sourceMappingURL=rma-terminal-statuses.js.map